/* Brand hex constants for SVG paint attributes (CSS vars don't resolve inside
   SVG fill/stroke). Keep in sync with styles/tokens.css. */
export const C = {
  navy: '#0C2340',
  navy75: '#3C5070',
  blue: '#004B87',
  blue60: '#5D93BF',
  cyan: '#00AEEF',
  platinum: '#98A4AE',
  slate: '#425563',
  mist: '#C2CDD4',
  fog: '#E2E8ED',
  paper: '#FFFFFF',
  paperWarm: '#F2F5F8',
  ok: '#1D9E75',
  warn: '#C9A02C',
  alert: '#C73E3E',
} as const

export type BrandColor = keyof typeof C
